const API_LIST = {
  common: {
    share: 'share/getFShareAutograph.show'
  },
  works: {
    list: 'oc/getCommonOperateList.wddl'
  },
  user: {
    sysTime: 'common/getSystemInfo.login',
    info: 'user/getSessionUserInfo.show',
    insertArt: 'artSchool/insertArtSchool.show',
    updateArt: 'artSchool/updateArtSchool.do',
    getList: 'artSchool/getArtSchoolList.show',
    getDetail: 'artSchool/getArtSchoolDetail.show',
    login: 'users/managerLogin.show',
    loginPic: 'common/getLoginCode.show',
    loginOut: 'common/loginOut.show',
    bindMobile: 'users/bindUserMobile.show', // 绑定手机/注册
    verifyCodes: 'common/getVerifyCodes.show', // 获取手机验证码
    checkCodes: 'common/checkVerifyCodes.show', // 验证验证码是否正确
    signature: 'common/getSignature.show',
    vote: 'oc/commonVote.wddl', // 用户投票

    province: 'common/getProvinceRegionList.show',
    cityOrCountry: 'common/getRegionListByPareaCode.show'
  },
  act: {
    allData: 'operate/allData.show',
    list: 'operate_content/getOpContentList.show',
    detail: 'operate/getFrontOperateContentDetail.show',
    special: 'operateUser/getExpertUserListByOperateCode.show',
    specialDetail: 'getSpecialDetail.show',
    sVote: 'ocStatistic/insertKaOcStatistic.do', // 专家投票
    upload: 'operate/userContribution.show',
    song: 'operate_content/insertKaOperateContent.show', // 歌词歌曲投稿
    totalNum: 'operate_content/getTotalNum.show',
    actDetail: 'operate_content/getOpContentDetail.show',
    songlist: 'oc/getCommonOperateList.wddl', // 音乐歌曲列表
    songdetail: 'oc/getCommonOperateDto.wddl' // 音乐歌曲详情
  },
  visit: {
    insert: 'visit/insertVisitInfo.show',
    read:'oc/userStatistic.jsyc'//阅读量
  },
  backEnd: {
    list: 'operate_content/getKaOperateContentList.show', // 后台获取投稿列表
    detail: 'operate_content/getKaOperateContent.show',
    // update: 'operate_content/updateKaOperateContent.do',
    check: 'operate_content/updateOpContentStatus.show', // 后台审核活动
    delete: 'operate_content/updateKaOperateContent.do'
  }
}

export default API_LIST



// WEBPACK FOOTER //
// ./src/api/config.js